import SelectedPhotoList from "./components/SelectedPhotoList";
import Button from "../../../components/Button/Button";
import { downloadFromUrl } from "../../../services/apis/common";
import { getAllSchoolFileCondition, createAllSchoolFile } from "../../../services/apis/StudioApi";
import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { useSnackbar } from "../../../components/Layout/SnackbarProvider";
import { wsHost } from "../../../services/apis/common";


const SelectedPhotosPage = () => {
    const { schoolId } = useParams();
    const [isDownloading, setIsDownloading] = useState(false)
    const [isCreating, setIsCreating] = useState(false)
    const [downloadAvailable, setDownloadAvailable] = useState(false)
    const { showSnackbar } = useSnackbar();
    const [socket, setSocket] = useState(null)
    const [message, setMessage] = useState("")
    const [progress, setProgress] = useState({ current: 0, total: 0 })
    const [progressPercentage, setProgressPercentage] = useState(0)
    const [errorMessage, setErrorMessage] = useState("")

    // 서명된 URL은 만료되므로 누를 때마다 새로 받아온다.
    const handleDownload = async () => {
        setIsDownloading(true)
        try {
            const res = await getAllSchoolFileCondition(schoolId)
            if (res.status === 200 && res.data.download_url) {
                downloadFromUrl(res.data.download_url)
            } else {
                showSnackbar("다운로드할 파일이 없습니다")
                setDownloadAvailable(false)
            }
        } catch (error) {
            console.error("다운로드 실패:", error)
            showSnackbar("다운로드 실패")
        } finally {
            setIsDownloading(false)
        }
    }

    const handleCreate = async () => {
        setIsDownloading(true)
        setIsCreating(true)
        setMessage("")
        setErrorMessage("")
        setProgress({ current: 0, total: 0 })
        setProgressPercentage(0)

        try {
            const res = await createAllSchoolFile({ schoolId: schoolId })

            if (res.status === 202) {
                // 선택 사진이 그대로면 서버가 재생성하지 않고 기존 파일 URL을 바로 준다.
                if (res.data.is_up_to_date === true && res.data.download_url) {
                    setMessage("이미 최신 파일이 있습니다. 다운로드를 시작합니다.")
                    setIsCreating(false)
                    setIsDownloading(false)
                    setDownloadAvailable(true)
                    downloadFromUrl(res.data.download_url)
                    return
                }
                setMessage("파일 생성이 시작되었습니다.")
                return
            }

            // 에러 처리
            if (res.status === 400) {
                setErrorMessage("파라미터 오류: schoolId를 확인해주세요.")
            } else if (res.status === 404) {
                setErrorMessage("선택된 사진이 없습니다.")
            } else {
                setErrorMessage(`오류가 발생했습니다. (${res.status})`)
            }
            showSnackbar("파일 생성 실패")
            setIsDownloading(false)
            setIsCreating(false)

        } catch (error) {
            console.error("파일 생성 요청 실패:", error)
            setErrorMessage("서버 오류가 발생했습니다.")
            showSnackbar("서버 오류")
            setIsDownloading(false)
            setIsCreating(false)
        }
    }

    const getBtnLabel = () => {
        if (isDownloading) {
            return "다운로드 요청중"
        }
        return "학생 전체 사진 다운로드"
    }

    useEffect(() => {
        getAllSchoolFileCondition(schoolId).then(
            res => {
                if (res.status === 200) {
                    // 여기서 받은 download_url은 만료되므로 보관하지 않는다.
                    // 실제 다운로드 시점에 handleDownload가 새로 받아온다.
                    setDownloadAvailable(true)
                    return;
                } else if (res.status === 204) {
                    setDownloadAvailable(false)
                    return
                } else {
                    console.log(res.status)
                    console.log(res.data)
                    return
                }
            }
        )
    }, [])

    useEffect(() => {
        const SOCKET_SERVER_URL = `${wsHost}ws/upload/${schoolId}/`
        const newSocket = new WebSocket(SOCKET_SERVER_URL);

        newSocket.onopen = () => {
            console.log("WebSocket Connected");
        };

        newSocket.onmessage = (event) => {
            const data = JSON.parse(event.data);
            console.log("WebSocket message:", data);

            if (data.message.startsWith("201-")) {
                // 생성 완료 메시지에 담긴 서명된 S3 URL로 바로 내려받는다.
                downloadFromUrl(data.message.substring(4));

                setMessage("파일 생성 완료! 다운로드가 시작됩니다.")
                setProgressPercentage(100)
                setIsCreating(false)
                setIsDownloading(false)
                setDownloadAvailable(true)
            } else if (data.message.startsWith("500-")) {
                // 서버에서 파일 생성 실패를 알린 경우: UI 잠금을 풀고 사유를 표시한다.
                const reason = data.message.substring(4);
                setErrorMessage(reason || "파일 생성 중 오류가 발생했습니다.")
                setMessage("")
                setIsCreating(false)
                setIsDownloading(false)
            } else {
                setDownloadAvailable(false)
                setMessage(data.message)

                // 진행률 파싱: "다운로드 파일 생성중 50/200"
                const match = data.message.match(/(\d+)\/(\d+)/)
                if (match) {
                    const current = parseInt(match[1])
                    const total = parseInt(match[2])
                    setProgress({ current, total })
                    setProgressPercentage(total > 0 ? Math.round((current / total) * 100) : 0)
                }
            }
        };

        newSocket.onerror = (error) => {
            console.error("WebSocket error:", error)
            setErrorMessage("실시간 연결 오류가 발생했습니다.")
        };

        setSocket(newSocket);

        return () => {
            if (newSocket.readyState === WebSocket.OPEN) {
                newSocket.close();
            }
        }
    }, [setSocket])

    return (
        <>
            <div className="flex flex-col w-screen">
                <div className="my-4 mx-16">
                    <Button onClick={handleCreate} disabled={isDownloading || isCreating}>
                        {isCreating ? (progress.total > 0 ? `파일 생성 중... (${progressPercentage}%)` : "파일 생성 중...") : "학생 전체 파일 생성"}
                    </Button>
                </div>

                {/* 진행 상황 표시 영역 */}
                {isCreating && (
                    <div className="mx-16 my-4">
                        <div className="flex justify-center mb-2 text-gray-700">
                            {message || "파일 생성 준비 중..."}
                        </div>
                        {progress.total > 0 && (
                            <div className="space-y-2">
                                <div className="flex justify-between text-sm text-gray-600">
                                    <span>진행률</span>
                                    <span>{progress.current} / {progress.total} ({progressPercentage}%)</span>
                                </div>
                                <div className="w-full bg-gray-200 rounded-full h-3">
                                    <div
                                        className="bg-blue-600 h-3 rounded-full transition-all duration-300"
                                        style={{ width: `${progressPercentage}%` }}
                                    ></div>
                                </div>
                            </div>
                        )}
                    </div>
                )}

                {/* 에러 메시지 표시 */}
                {errorMessage && (
                    <div className="mx-16 my-2 p-3 bg-red-100 border border-red-400 text-red-700 rounded">
                        {errorMessage}
                    </div>
                )}

                {/* 완료 후 메시지 (생성 중이 아닐 때만) */}
                {!isCreating && message && (
                    <div className="flex justify-center my-2 text-green-600">
                        {message}
                    </div>
                )}

                <div className="mx-16">
                    <Button onClick={handleDownload} disabled={isDownloading || !downloadAvailable || isCreating} disabled_label={isDownloading ? "처리중" : "파일 없음"}>{getBtnLabel()}</Button>
                </div>
                <div className="p-2">
                    <SelectedPhotoList />
                </div>
            </div>
        </>
    )
}

export default SelectedPhotosPage;